import React, { Component } from "react";
import PropTypes from "prop-types";
import YouTube from "react-youtube";
import styles from "./style.module.scss";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { isMobileOnly } from "react-device-detect";
import { uniqueId } from "lodash";

const playerOptions = {
  playerVars: {
    disablekb: "1",
    modestbranding: "0",
    rel: "0",
    autoplay: true,
    controls: "0",
    showinfo: "0"
  }
};

class Video extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.videoEnded = this.videoEnded.bind(this);
    this.openFullScreen = this.openFullScreen.bind(this);

    this.id = uniqueId("player_");
  }

  openModal() {
    this.setState({ open: true });
  }

  closeModal(e) {
    e.stopPropagation();
    this.setState({ open: false });
  }

  videoEnded() {
    window.setTimeout(() => this.setState({ open: false }), 2000);
  }

  openFullScreen() {
    const iframe = document.querySelector(`#${this.id}`);

    const requestFullScreen =
      iframe.requestFullScreen ||
      iframe.mozRequestFullScreen ||
      iframe.webkitRequestFullScreen;
    if (requestFullScreen) {
      requestFullScreen.bind(iframe)();
    }
  }

  renderDesktop() {
    const { videoId, poster } = this.props;
    const { open } = this.state;

    return (
      <TransitionGroup
        className={styles.VideoTransition}
        onClick={this.openModal}
      >
        <div className={styles.posterContainer}>
          <img className={styles.posterImg} src={poster} alt="people-video" />
          <img className={styles.playButton} src="/video/play.svg" alt="" />
        </div>
        {open && (
          <CSSTransition
            classNames={{
              enter: styles.enter,
              enterActive: styles.enterActive,
              exit: styles.exit,
              exitActive: styles.exitActive
            }}
            timeout={300}
          >
            <div className={styles.playerModal} onClick={this.closeModal}>
              <YouTube
                containerClassName={styles.playerContainer}
                className={styles.player}
                videoId={videoId}
                opts={playerOptions}
                onEnd={this.videoEnded}
              />
            </div>
          </CSSTransition>
        )}
      </TransitionGroup>
    );
  }

  renderMobile() {
    const { videoId } = this.props;

    return (
      <YouTube
        id={this.id}
        containerClassName={styles.playerContainer}
        className={styles.player}
        videoId={videoId}
        opts={playerOptions}
        onPlay={this.openFullScreen}
      />
    );
  }

  render() {
    return (
      <div className={styles.Video}>
        {isMobileOnly ? this.renderMobile() : this.renderDesktop()}
      </div>
    );
  }
}

Video.propTypes = {
  poster: PropTypes.string,
  videoId: PropTypes.string
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video/index.js